__turbopack_context__.v({
  "component__address": "HqzmPG_component__address",
  "component__addressWrapper": "HqzmPG_component__addressWrapper",
  "component__buttonWrapper": "HqzmPG_component__buttonWrapper",
  "component__close": "HqzmPG_component__close",
  "component__contentWrapper": "HqzmPG_component__contentWrapper",
  "component__headerBadge": "HqzmPG_component__headerBadge",
  "component__headerIcon": "HqzmPG_component__headerIcon",
  "component__heading": "HqzmPG_component__heading",
  "component__icon": "HqzmPG_component__icon",
  "component__modalContainer": "HqzmPG_component__modalContainer",
  "component__subheading": "HqzmPG_component__subheading",
});
